import { type UseQueryResult, useQuery } from 'react-query';
import {
  TwoFactorConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto,
} from '../../services/wealthlane-identity-services';

const useGetIsTwoFactorEnabled = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto | undefined,
  unknown
> => {
  return useQuery(['getIsTwoFactorEnabled'], async () => {
    return await handleRequest(
      TwoFactorConfigurationService.getApiIdentityApiTwoFactorConfigurationIsTwoFactorEnabled()
    );
  });
};

export default useGetIsTwoFactorEnabled;
